import { keyframes } from '@emotion/react';

export const flipFromRight = keyframes`
  from {
    opacity: 0;
    transform: rotateY(90deg);
  }

  to {
    opacity: 1;
    transform: rotateY(0deg); 
  }
`;

export const flipFromLeft = keyframes`
  from {
    opacity: 0;
    transform: rotateY(90deg);
  }

  to {
    opacity: 1;
    transform: rotateT(0deg);
  }
`;
